module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Moon.777abc6b.png";